import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emergency",
  "use": "emergency-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"emergency\"><path fill-rule=\"evenodd\" d=\"M18 15.75v-5c0-3.07-1.64-5.64-4.5-6.32v-.68c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.11 6 7.67 6 10.75v5l-2 2v1h16v-1l-2-2Zm-5 0h-2v-2h2v2Zm0-4h-2v-4h2v4Zm-1 10c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol